import { fromJS } from 'immutable';
import { CSS_LOADING } from '../config/actions';
import { FETCH_CASE, GET_PORTAL_CASE } from '../cases';
import { FETCH_CUSTOMERBYID } from '../customers';
import { GET_OFFER } from '../offers';

export const initialState = fromJS({
  loading: false,
  isCssLoaded: false,
  isCustomerLoaded: false,
  isCaseLoaded: false
});

export default function loaderReducer(state = initialState, action) {
  if (action.meta && action.meta.loading !== undefined) {
    return state.set('loading', action.meta.loading);
  }
  if (action.type) {
    if (action.type === CSS_LOADING) {
      return state.set('isCssLoaded', action.isCssLoaded);
    }
    if (action.type.indexOf(FETCH_CASE || GET_PORTAL_CASE) > -1) {
      return state.set('isCaseLoaded', action.meta.isCaseLoaded).set('loading', false);
    }
    if (action.type.indexOf(FETCH_CUSTOMERBYID) > -1) {
      return state.set('isCustomerLoaded', action.meta.isCustomerLoaded);
    }
    if (action.type.indexOf(GET_OFFER) > -1) {
      return state.set('isOfferLoaded', action.meta.isOfferLoaded);
    }
  }
  return state;
}
